module.exports = __webpack_public_path__ + "static/media/presskit_info_icon.82d60708.png";